import { render, staticRenderFns } from "./update-document-detail.component.vue?vue&type=template&id=151af60d&"
import script from "./update-document-detail.component.vue?vue&type=script&lang=ts&"
export * from "./update-document-detail.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports